import React from 'react';
import { Redirect } from 'react-router-dom'
import LayoutRoute from './LayoutRoute'
import { store } from '../../redux/store';

function NonAuthenticatedRoute(route: any) {
    const user = store.getState().auth.user
    if (user) {
        return <Redirect to={{ pathname: '/' , state: { from: route.location.pathname}}} />
    } else {
        return <LayoutRoute {...route} />
    }
}

export default NonAuthenticatedRoute;